"use client";

import React, { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheGrainOfTime() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  return <section id="the-grain-of-time" ref={ref} className="dark bg-background text-foreground relative h-screen w-full overflow-hidden flex flex-col items-center justify-center">
      {}
      <style jsx global>{`
        @keyframes grain {
          0%, 100% { transform: translate(0, 0); }
          10% { transform: translate(-5%, -10%); }
          20% { transform: translate(-15%, 5%); }
          30% { transform: translate(7%, -25%); }
          40% { transform: translate(-5%, 25%); }
          50% { transform: translate(-15%, 10%); }
          60% { transform: translate(15%, 0%); }
          70% { transform: translate(0%, 15%); }
          80% { transform: translate(3%, 35%); }
          90% { transform: translate(-10%, 10%); }
        }
        .animate-grain {
          animation: grain 8s steps(10) infinite;
        }
      `}</style>

      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1556059/img/street_scene_dusk_grain.png)] bg-cover bg-center opacity-40" />
        <div className="absolute inset-0 bg-black/60" /> {}
      </div>

      {}
      <div className="pointer-events-none absolute inset-0 z-1 opacity-15 overflow-hidden">
        <div className="animate-grain absolute -top-[50%] -left-[50%] w-[200%] h-[200%] bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1556059/img/film_grain_overlay.png)] bg-repeat" />
      </div>

      {}
      <div className={`z-10 flex flex-col items-center text-center gap-8 px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        {}
        <h1 className="font-serif text-6xl md:text-8xl lg:text-9xl text-foreground tracking-tighter drop-shadow-2xl">
          The Grain of Time
        </h1>

        {}
        <div className="flex items-center gap-4 text-xs md:text-sm font-mono tracking-[0.2em] text-muted-foreground/80 uppercase">
          <span>1/500s</span>
          <span className="text-primary">•</span>
          <span>f/2.8</span>
          <span className="text-primary">•</span>
          <span>ISO 400</span>
        </div>

        {}
        <div className="mt-4">
          <Button asChild variant="ghost" className="text-lg font-medium tracking-wide text-foreground/90 hover:text-primary hover:bg-transparent transition-all duration-500 hover:drop-shadow-[0_0_15px_var(--color-primary)]">
            <Link to="/TheArchivesPage">
              Explore Archives
            </Link>
          </Button>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 z-10 pb-12 opacity-80">
        <div className="h-24 w-[1px] bg-gradient-to-b from-transparent via-foreground to-transparent animate-pulse" />
      </div>
    </section>;
}